import { scrollObserver, scrollToOptions } from "./utilities";

const animationScrollOptions = scrollToOptions(undefined, undefined, 0);
const animationsFunction = scrollObserver(
  animateSectionElements,
  animationScrollOptions
);

function animateSectionElements(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.remove("animations");
      entry.target.classList.add("animate");
    }
  });
}

window.addEventListener("load", () => {
  const pageElements = document.querySelectorAll(".animation");

  pageElements.forEach((section) => {
    animationsFunction.observe(section);
  });

  //Staggered animation for child elements

  const staggeredContainers = document.querySelectorAll(
    "[data-animation-stagger]"
  );
  staggeredContainers.forEach((staggeredContainer) => {
    const delayStep = parseFloat(
      staggeredContainer.getAttribute("data-animation-stagger")
    );
    const children = staggeredContainer.children;
    for (let i = 0; i < children.length; i++) {
      children[i].style.transitionProperty = "opacity";
      children[i].style.transitionDelay = `${0.5 + i * delayStep}s`;
    }
  });
});
